import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsParkingRule} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsParkingPassesService} from '../../../services/settings-parking-passes.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'legal-agreement-modal',
    templateUrl: './legal-agreement-modal.component.html',
    styleUrls: ['./legal-agreement-modal.component.scss']
})
export class LegalAgreementModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: SettingsParkingRule = new SettingsParkingRule();
    disabledSubmit = false;
    dataIsBeingUpdated = false;
    disabledFileInput = false;
    attachments: Array<any> = [];
    showLegalAgreementEditPanel = false;
    showConfirmationMessageEditPanel = false;
    legalAgreement = '';
    confirmationMessageInputDisabled = false;

    constructor(
        public api: ApiClientService,
        public settingsParkingPassesService: SettingsParkingPassesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.settingsParkingPassesService.onDataSend.subscribe(() => this.dataIsBeingUpdated = true);
        this.settingsParkingPassesService.onDataReceived.subscribe(() => this.dataIsBeingUpdated = false);
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.legalAgreement = this.settingsParkingPassesService.selectedItemData.legalAgreement ? this.settingsParkingPassesService.selectedItemData.legalAgreement.slice() : '';
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsParkingPassesService.isLegalAgreementModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsParkingPassesService.isLegalAgreementModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(data) {
        if(data[Object.keys(data)[0]] == '' || (data[Object.keys(data)[0]].replace(/&nbsp;/g, '')).replace(/\s/g, '').replace(/<br>/g, '') == '') {
            toastr.warning(Object.keys(data)[0] == 'legalAgreement' ?
                ('Legal Agreement' + ' should not be blank.') : ('Confirmation Message' + ' should not be blank.'));
            return;
        }

        this.disabledSubmit = true;
        this.confirmationMessageInputDisabled = true;
        if(Object.keys(data)[0] == 'legalAgreement')
            this.showLegalAgreementEditPanel = false;
        this.settingsParkingPassesService.api.patch('domainParkingPass',
            `${this.settingsParkingPassesService.parkingPassesData.rules.patch}${this.settingsParkingPassesService.selectedItemData.id}.json`, data).subscribe(
            () => this.updateView('The Field was successfully updated'),
            (error) => { this.api.errorHandler(error, 'Update Parking Pass failed'); },
            () => {
                this.disabledSubmit = false;
                this.confirmationMessageInputDisabled = false;
            }
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsParkingPassesService.getData();
        this.form.reset();
    }

    initSummernote(id) {
        const summernote = $(id);
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.legalAgreement = contents},
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr']],
                ['help', ['help']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');
        $('.note-editable').html(this.legalAgreement).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    showLegalAgreementEditPanelSetter(): void {
        this.showLegalAgreementEditPanel = true;
        setTimeout( () => this.initSummernote('#summernote'), 300);
    }

    closeLegalAgreementEditPanel() {
        this.showLegalAgreementEditPanel = false;
        this.legalAgreement = this.settingsParkingPassesService.selectedItemData.legalAgreement ? this.settingsParkingPassesService.selectedItemData.legalAgreement.slice() : '';
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-parking-passes/legal-agreement-modal/legal-agreement-modal.component.ts